import React, {ReactNode, useEffect, useState} from "react";
import {Button, Row, Col, Upload, Form, message} from "antd";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import {tabKeys} from "types/enums";

const SetHeader = () => {
  const dispatch = useAppDispatch();

  const activeTab = useAppSelector(state => state.common.activeTab);
  const SubmitButton = () => {
    return (
      <Button className="btn-sub" type="ghost">
        Button của tab {tabKeys.SAMPLE.SET_HEADER}
      </Button>
    );
  };
  useEffect(() => {
    if (activeTab == tabKeys.SAMPLE.SET_HEADER) {
      dispatch(setButtonsHeader([SubmitButton(), SubmitButton()]));
    }
  }, [activeTab]);
  return <div className="container"></div>;
};
export default SetHeader;
